import React, { useState } from 'react'

import { Title } from '../presentation/Text'
import { useForceOpenActions, useForceOpenObservable } from '../helpers/OpenCloseGroup'
import Center from '../helpers/Center'
import FlexGrid, { FlexCol } from './FlexGrid'
import Icon from '../shapes/Icon'
import Link from '../actions/Link'
import Panel from './Panel'
import Plain from '../helpers/Plain'
import Separator from '../helpers/Separator'
import Sticky from '../helpers/Sticky'
import { COLORS } from '@btime/constants'

// TODO: Move to accordion/Accordion
// DEPRACATED: Use accordion/Accordion
const Accorion = ({
  children,
  disableToggle,
  sticky,
  label,
  side,
  sideTitle,
  startsOpen,
  noPanel,
  hideSideTitleIfOpen,
  headerContent
}) => {
  const [open, setOpen] = useState(!!startsOpen)
  const { handleToggle } = useForceOpenActions()

  const onToggle = () => {
    if (disableToggle) return
    const newValue = !open
    setOpen(newValue)
    handleToggle && handleToggle(newValue)
  }

  useForceOpenObservable(open, setOpen)

  const icon = 'BsChevron' + (open ? 'Down' : 'Right')

  const content = open && (
    <div>
      <Separator weight={8} />
      {children}
    </div>
  )

  const Wrapper = noPanel ? Plain : Panel
  const HeaderWrapper = sticky ? Sticky : Plain
  const showSideTitle = (!hideSideTitleIfOpen || !!open) && sideTitle

  return (
    <Wrapper noMargin style={{ paddingBottom: '1rem', paddingTop: '1rem', width: '100%' }}>
      <HeaderWrapper bgColor={COLORS.white}>
        {headerContent || (
          <FlexGrid justify="flex-start" gutter={0.5} wrap>
            {!disableToggle && (
              <Link onClick={onToggle} block>
                <Center>
                  <Icon name={icon} color={COLORS.dark2} size={!!noPanel && '1rem'} />
                </Center>
              </Link>
            )}
            <FlexCol flex={1}>
              <FlexGrid justify="flex-start" gutter={0.5} wrap>
                <Link onClick={onToggle} block>
                  <Title size={!noPanel ? 'h4' : 'h6'} color={COLORS.dark2} noMargin>
                    {label}
                  </Title>
                </Link>
                {showSideTitle && (
                  <FlexCol wrapOn="sm" widthOnSm="100%" orderOnSmall="3">
                    {sideTitle}
                  </FlexCol>
                )}
              </FlexGrid>
            </FlexCol>
            {side}
          </FlexGrid>
        )}
      </HeaderWrapper>
      {content}
    </Wrapper>
  )
}

export default Accorion
